import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { DepartmentModel } from 'src/app/core/models/DepartmentModel';
import { PriorityLevelEnum, PriorityLevelMapping } from 'src/app/core/models/PriorityLevelEnum';
import { QueryCategoryModel } from 'src/app/core/models/QueryCategoryModel';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QuerySubCategoryModel } from 'src/app/core/models/QuerySubCategoryModel';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { User } from 'src/app/core/models/user';
import { UserService } from 'src/app/core/services/user.service';
import { ClarificationQueryListService } from '../clarification-query-list.service';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Constants } from 'src/app/constants/constants';


@Component({
  selector: 'app-reopen-query',
  standalone: false,
  templateUrl: './reopen-query.component.html',
  styleUrl: './reopen-query.component.less'
})
export class ReopenQueryComponent implements OnInit {
  priorityLevelMapping = PriorityLevelMapping;
  priorityLevels = Object.values(PriorityLevelEnum);
  public Constants = Constants; // Expose Constants to the template

  currentUser: User = new User();
  queryCode: number = 0;
  queryModel: QueryModel = new QueryModel();
  queryDetail: QueryDetailModel = new QueryDetailModel();;

  dropdownSettings = {};
  output: any;
  blockMaster: BlockModel[] = [];
  departmentMaster: DepartmentModel[] = [];
  subDeptMaster: SubDepartmentModel[] = [];
  deptSubDeptMaster: SubDepartmentModel[] = [];;
  categoryMaster: QueryCategoryModel[] = [];
  subCatMaster: QuerySubCategoryModel[] = [];
  partnerUserMaster: RegisteredUserModel[] = [];
  selectedCCPartnerUsers = [];

  reOpenQueryForm!: FormGroup; // Reactive FormGroup

  invalidEmails = '';
  showInvalidEmails = false;

  files: File[] = [];
  errorMsg = "Error occurred while fetching the query details";
  errorMsgUnAuth = "You are not authorized to reopen/view the selected Query Details.";


  regExps = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private userService: UserService,
    private queryService: ClarificationQueryListService,
    private dbMasterService: DbMasterService,
    private datePipe: DatePipe
  ) {
    this.queryCode = +(this.route.snapshot.paramMap.get('queryCode') ?? 0);
  }
  ngOnInit() {    
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    // if (!this.currentUser.Is_Partner) { // MANAS_TBD -- check with original page for ef condition
    //   this.redirectToHome(this.errorMsgUnAuth);
    // } else if (this.queryCode == 0) {
    //   this.redirectToHome("Please select proper query reference number");
    // } else {
    //   this.initialiseData();
    this.initializeReOpenQueryForm();
    this.queryService.getQueryDetail(this.queryCode, this.currentUser.User_Code ?? 0).subscribe({
      next: (response: any) => {
        const queryResponse = response as { isAccessible: boolean; output: any }; // Explicitly cast the response
        this.queryModel = queryResponse.output;
        this.populateForm();
        // if (
        //   queryResponse.isAccessible &&
        //   queryResponse.output.RequestorDetail.User_Code === this.currentUser.User_Code
        // ) {
        //   this.queryModel = queryResponse.output;
        // } else {
        //   this.redirectToHome("You are not authorized to reopen the selected Query Details.");
        // }
        this.loadMasterData();
      },
      error: (error: { status: number }) => {
        this.redirectToHome(error.status === 404 ? this.errorMsgUnAuth : this.errorMsg);
      },
    });
    //}
  }
  initializeReOpenQueryForm() {
    // Initialize the reactive form    
    this.reOpenQueryForm = this.fb.group({
      QueryReferenceNumber: [{ value: '', disabled: true }],
      dateOfRequest: [{ value: '', disabled: true }],
      QueryStatus: [{ value: 'Re-Open', disabled: true }],
      Priority: [null, Validators.required],
      Is_Confidential: [false],
      CCEmails: ['', [this.validateEmails]],
      RequestorName: [{ value: '', disabled: true }],
      RequestorEmail: [{ value: '', disabled: true }],
      CompanyName: [{ value: '', disabled: true }],
      block: [
        {
          value: this.currentUser.Block?.Block_Code != Constants.ALL_BLOCK_CODE
            ? this.currentUser.Block?.Block_Name
            : null,
          disabled: this.currentUser.Block?.Block_Code != Constants.ALL_BLOCK_CODE
        },
        Validators.required
      ],
      department: [null],
      subDepartment: [null],
      cc: [[]], // Multi-select dropdown
      partnerComments: ['', Validators.required]
    });
    
    // Populate the form with initial data
    //this.populateForm();
  }
  validateEmails(control: any): { [key: string]: any } | null {
    const emails = control.value?.split(';') || [];
    const invalidEmails = emails.filter(
      (email: string) => email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
    );

    // Return an error object if there are invalid emails

    var data = invalidEmails.length > 0
      ? { invalidEmails: invalidEmails.join(', ') }
      : null; // Return null if there are no errors      
    return data;
  }

  populateForm(): void {
    this.reOpenQueryForm.patchValue({
      QueryReferenceNumber: this.queryModel.Query_Reference_Number,
      dateOfRequest: this.datePipe.transform(this.queryModel.Created_Date, 'dd-MMM-yyyy') || '',
      RequestorName: this.queryModel.RequestorDetail?.User_Name,
      RequestorEmail: this.queryModel.RequestorDetail?.Email,
      CompanyName: this.queryModel.QueryDetail?.CompanyName,
      block: this.queryModel.QueryDetail.Block,
      Priority: [PriorityLevelEnum.Low],//[this.queryDetail.PriorityLevel_Id],
      Is_Confidential: this.queryDetail.Is_Confidential,
      CCEmails: this.queryDetail.CCEmails,
      confidential: this.queryDetail.Is_Confidential,
      //department: this.queryDetail.Department_Code,
      //subDepartment: this.queryDetail.Sub_Dept_Code,
      partnerComments: this.queryDetail.Partner_Comment
    });
    
  }
  onSubmit(): void {
    if (this.reOpenQueryForm.valid) {
      
      this.modalService.confirm({
        nzTitle: 'Confirm!',
        nzContent: `Are you sure, you want to <b>Re-Open the Query?</b>`,
        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzClosable: false,
        nzOkDanger: true,
        nzOnOk: () => this.reopenQuery(),
        nzCancelText: 'No'
      });
    } else {
      console.error('Form is invalid');
    }
  }
  reopenQuery() {
    this.queryDetail.Clarification_Query_Code = this.queryModel.QueryDetail.Clarification_Query_Code;
    this.queryDetail.Clarification_Query_Detail_Code = this.queryModel.QueryDetail.Clarification_Query_Detail_Code;
    this.queryDetail.Block_Code = this.queryModel.QueryDetail.Block_Code;
    this.queryDetail.Modified_By = (this.currentUser.User_Code ?? 0).toString();
    this.queryDetail.CCEmails = this.reOpenQueryForm.get('CCEmails')?.value;
    this.queryDetail.PriorityLevel_Id = 1; //this.queryDetail.PriorityLevel_Id = this.reOpenQueryForm.get('Priority')?.value; MANAS_TBD -- check with original page for ef condition
    this.queryDetail.Department_Code = this.reOpenQueryForm.get('department')?.value;
    this.queryDetail.Sub_Dept_Code = this.reOpenQueryForm.get('subDepartment')?.value;
    this.queryDetail.Is_Confidential = this.reOpenQueryForm.get('Is_Confidential')?.value;
    this.queryDetail.CCUsers = this.reOpenQueryForm.get('cc')?.value;
    this.queryDetail.Partner_Comment = this.reOpenQueryForm.get('partnerComments')?.value
    
    this.queryService.reopenQuery(this.queryDetail, this.files).subscribe({
      next: (response: any) => {
        this.messageService.success("A query has been Re-Opened successfully!", { nzDuration: Constants.SHOW_MESSAGE_DURATION });
        this.router.navigate(['/clarification-query/my-query']);
      },
      error: (err: any) => {
        this.messageService.error(err.error || "An error occurred while reopening the query.");
        console.error("Error reopening query:", err);
      }
    });
  }
  redirectToHome(erroMsg: string) {
    this.messageService.error(erroMsg);
    console.log(erroMsg);
    this.router.navigate(['/home']);
  }
  initialiseData() {
    this.queryModel.RequestorDetail = new User();
    this.queryModel.QueryDetail = new QueryDetailModel();
    this.queryDetail.Block_Code = (this.currentUser.Block?.Block_Code === Constants.ALL_BLOCK_CODE) ? 0 : (this.currentUser.Block?.Block_Code ?? 0);
    this.queryDetail.PriorityLevel_Id = Number(PriorityLevelEnum.Low);
    this.queryDetail.Department_Code = "";
    this.queryDetail.Sub_Dept_Code = "";
    this.queryDetail.CCEmails = "";

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'User_Code',
      textField: 'User_Name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  loadMasterData() {
    this.dbMasterService.getMasterDetails().subscribe({
      next: (response: any) => {
        this.output = response.output;
        this.blockMaster = this.output.Block as [];
        this.categoryMaster = this.output.Category as [];
        this.subCatMaster = this.output.SubCategory as [];
        this.departmentMaster = this.output.Department.filter((dept: DepartmentModel) => dept.Active) as [];
        this.subDeptMaster = this.output.SubDepartment.filter((subDept: SubDepartmentModel) => subDept.Active) as [];
        this.partnerUserMaster = this.output.PartnerUsers.filter((user: RegisteredUserModel) => user.Active) as [];
        this.deptSubDeptMaster = [];
      },
      error: (error: any) => {
        this.messageService.error("Error occurred while fetching master details");
        console.log(error);
        this.router.navigate(['/home']);
      }
    });
  }

  onDepartmentChange(department_Code: string) {
    this.deptSubDeptMaster = [];
    this.queryDetail.Sub_Dept_Code = "";
    
    // Clear the subDepartment field in the form
    this.reOpenQueryForm.patchValue({
      subDepartment: ''
    });

    this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == department_Code);
    
  }
  
}
